import { useEffect, useState } from 'react';
import { getServerApiDietDetails } from '../api/client/companyDetailsApi';
import { extractDietsAndTiers } from '../helpers/extractDietsAndTiers';

const useGetCompanyDietsDetails = companyId => {
  const [companyDietDetails, setCompanyDietDetails] = useState(null);

  useEffect(() => {
    if (companyId) {
      getServerApiDietDetails(companyId)
        .then(data =>
          setCompanyDietDetails(extractDietsAndTiers(data.programs))
        )
        .catch(error => console.log(error));
    }
  }, [companyId]);

  return { companyDietDetails };
};

export default useGetCompanyDietsDetails;
